import { Component, OnInit, inject } from '@angular/core';
import { NotificationService } from '@ntap/core';
import {
  BehaviorSubject,
  Observable,
  catchError,
  map,
  of,
  switchMap,
  tap
} from 'rxjs';
import { UpravnaStvarService } from '../upravna_stvar.service';

@Component({
  selector: 'app-upravna-stvar-sifrarnik',
  templateUrl: './upravna_stvar_list.component.html',
  providers: [UpravnaStvarService]
})
export class UpravnaStvarListComponent implements OnInit {
  upravnaStvarService = inject(UpravnaStvarService);
  upravneStvari$: Observable<any>;
  //private refreshSubject: Subject<void> = new Subject<void>();
  private refreshSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private notificationService: NotificationService =
    inject(NotificationService);
  upravneStvari: any;

  ngOnInit(): void {
    this.upravneStvari$ = this.refreshSubject.pipe(
      switchMap((updated) =>
        this.upravnaStvarService.getUpravneStvari().pipe(
          map((data) => this.convertToTreeTableFormat(data)),
          tap((data) => {
            this.expandAllNodes(data);
            if (updated.updated === true) {
              this.notificationService.success(
                'Upravne stvari su uspješno ažurirane!'
              );
            }
          }),
          catchError(() => {
            this.notificationService.error(
              'Pogreška prilikom dohvata upravnih stvari!'
            );
            return of([]);
          })
        )
      )
    );
    this.refreshList({ updated: false });
  }

  convertToTreeTableFormat(originalData: any[]): any {
    return originalData.map((node) => {
      return {
        data: {
          label: node.label,
          key: node.key,
          selectable: node.selectable
        },
        children: node.children
          ? this.convertToTreeTableFormat(node.children)
          : []
      };
    });
  }

  updateUpravneStvari() {
    this.upravnaStvarService
      .updateUpravneStvar()
      .subscribe(() => this.refreshList({ updated: true }));
  }

  refreshList(updated: object) {
    this.refreshSubject.next(updated);
  }

  expandAllNodes(nodes: any[]) {
    nodes.forEach((node) => {
      node.expanded = true;
      if (node.children && node.children.length) {
        this.expandAllNodes(node.children);
      }
    });
  }
}
